module.exports = __webpack_public_path__ + "img/3a.086f2004.jpg";